import React, { useState, useEffect } from 'react';
import './App.css';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';


export default function App() {
  const [usedItems, setUsedItems] = useState([]);
  const [dropItems, setDropItems] = useState([]);
  const [itemDB, setItemDB] = useState([]);

  const [useName, setUseName] = useState('');
  const [useAmount, setUseAmount] = useState('');
  const [usePrice, setUsePrice] = useState('');

  const [dropName, setDropName] = useState('');
  const [dropAmount, setDropAmount] = useState('');

  // 🔥 Load items from Firestore
  useEffect(() => {
    const fetchItems = async () => {
      const querySnapshot = await getDocs(collection(db, 'items'));
      const items = querySnapshot.docs.map(doc => doc.data());
      setItemDB(items);
    };
    fetchItems();
  }, []);

  const addUsedItem = () => {
    if (useName && useAmount && usePrice) {
      setUsedItems([...usedItems, {
        name: useName,
        amount: parseInt(useAmount),
        price: parseFloat(usePrice)
      }]);
      setUseName('');
      setUseAmount('');
      setUsePrice('');
    }
  };

  const addDropItem = () => {
    if (dropName && dropAmount) {
      setDropItems([...dropItems, {
        name: dropName,
        amount: parseInt(dropAmount)
      }]);
      setDropName('');
      setDropAmount('');
    }
  };

  const totalUsed = usedItems.reduce((sum, item) => sum + item.amount * item.price, 0);
  const totalDrop = dropItems.reduce((sum, item) => {
    const dbItem = itemDB.find(db => db.name === item.name);
    return dbItem ? sum + dbItem.price * item.amount : sum;
  }, 0);
  const profit = totalDrop - totalUsed;

  return (
    <div className='mainScreen'>
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-gray-100 font-sans">
        <div className="screenContent">
          <h1 className="text-3xl font-bold text-center mb-6">Lineage 2 Profit Calculator</h1>

          <div className="secondScreen grid md:grid-cols-2 gap-6">
            {/* What I Use */}
            <div className="p-4 bg-gray-800 rounded-xl shadow">
              <h2 className="text-lg font-semibold mb-2">What I Use</h2>
              <input value={useName} onChange={e => setUseName(e.target.value)} placeholder="Name" className="input mb-2" />
              <input value={useAmount} onChange={e => setUseAmount(e.target.value)} placeholder="Amount" type="number" className="input mb-2" />
              <input value={usePrice} onChange={e => setUsePrice(e.target.value)} placeholder="Price per Item" type="number" className="input mb-2" />
              <button onClick={addUsedItem} className="btn">Add</button>
              <ul className="mt-2 text-sm">
                {usedItems.map((item, i) => (
                  <li key={i}>{item.name} - {item.amount} × {item.price} = {item.amount * item.price} adena</li>
                ))}
              </ul>
            </div>

            {/* What I Drop */}
            <div className="p-4 bg-gray-800 rounded-xl shadow">
              <h2 className="text-lg font-semibold mb-2">What I Drop</h2>
              <select value={dropName} onChange={e => setDropName(e.target.value)} className="input mb-2">
                <option value="">Select item</option>
                {itemDB.map((item, i) => (
                  <option key={i} value={item.name}>{item.name}</option>
                ))}
              </select>
              <input value={dropAmount} onChange={e => setDropAmount(e.target.value)} placeholder="Amount" type="number" className="input mb-2" />
              <button onClick={addDropItem} className="btn">Add</button>
              <ul className="mt-2 text-sm">
                {dropItems.map((item, i) => (
                  <li key={i}>{item.name} - {item.amount}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Profit Display */}
          <div className="w-full mt-6 mb-6 p-4 bg-gray-700 text-center rounded-xl">
            <h2 className="text-xl font-bold">Profit</h2>
            <p className="text-2xl text-green-400 font-mono">{profit} adena</p>
          </div>

          {/* Item DB Display */}
          <div className="w-full p-4 bg-gray-800 rounded-xl shadow">
            <h2 className="text-lg font-semibold mb-2">L2Reborn Signature Market Database</h2>
            <table className="mt-4 w-full text-sm" >
              <thead>
                <tr className="text-left border-b border-gray-600">
                  <th className="py-1">Name</th>
                  <th className="py-1">Price</th>
                </tr>
              </thead>
              <tbody>
                {itemDB.map((item, i) => (
                  <tr key={i} className="border-b border-gray-700">
                    <td className="py-1 pr-4">{item.name}</td>
                    <td className="py-1 pr-4">{item.price} adena</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <style jsx>{`
            .input {
              display: block;
              width: 100%;
              padding: 0.5rem;
              margin-bottom: 0.5rem;
              background-color: #1f2937;
              color: #f9fafb;
              border: 1px solid #374151;
              border-radius: 0.5rem;
            }
            .btn {
              background: #10b981;
              color: white;
              padding: 0.5rem 1rem;
              border-radius: 0.5rem;
              font-weight: bold;
              margin-right: 0.5rem;
            }
            .btn:hover {
              background: #059669;
            }
          `}</style>
        </div>
      </div>
    </div>
  );
}
